import moment from "moment"
import ehDiaUtil from "@lfreneda/eh-dia-util"

moment.locale("pt-BR")

moment.formatAge = (date) => {

  if (!date)
    return ""

  let label = "Ainda não nasceu"
  const today = moment(new Date())
  const birthDate = moment(date)
  const days = today.diff(birthDate, "days")
  const months = today.diff(birthDate, "months")  
  const years = today.diff(birthDate, "years")  
  
  if (years > 0) {
    label = years == 1 ? "1 ano" : years + " anos"
  } else if (months > 0) {
    label = months == 1 ? "1 mês" : months + " meses"
  } else if (days >= 0) {
    label = days <= 1 ? "1 dia" : days + " dias"
  }
  
  return label
}

moment.getNextBusinessDay = (date) => {

  if (!date)
    return new Date()

  let businessDay = moment(date).toDate()  

  while (!ehDiaUtil(businessDay)) {
    businessDay = moment(businessDay).add(1, "days").toDate()
  } 
  
  return businessDay
}

moment.getFirstDayOfWeek = (date) => {

  if (!date)
    date = new Date()

  let firstDay = null
  let currentWeek = moment(date).week()

  while (moment(date).week() == currentWeek) {
    firstDay = moment(date).toDate()
    date = decrementDayAt(date)    
  }

  return firstDay
}

moment.getLastDayOfWeek = (date) => {

  if (!date)
    date = new Date()

  let lastDay = null
  let currentWeek = moment(date).week()

  while (moment(date).week() == currentWeek) {
    lastDay = moment(date).toDate()
    date = incrementDayAt(date)    
  }

  return lastDay
}

moment.getLastDayOfMonth = (date) => {

  if (!date)
    date = new Date()

  let lastDay = null
  let currentMonth = date.getMonth()

  while (date.getMonth() == currentMonth) {
    lastDay = moment(date).toDate()
    date = incrementDayAt(date)    
  }

  return lastDay
}

function incrementDayAt(date) {
  return moment(date).add(1, "days").toDate()
}

function decrementDayAt(date) {
  return moment(date).subtract(1, "days").toDate()
}

export default moment
